/**
 * @generated SignedSource<<764f6ddfadde08d02c8d1d4cfd5c9c0e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type StorecastScreenAdminSelectDashboardMutation$variables = {
  dashboardId: string;
  screenId: string;
};
export type StorecastScreenAdminSelectDashboardMutation$data = {
  readonly storecast: {
    readonly setScreenDashboard: {
      readonly dashboard: {
        readonly id: string;
        readonly name: string;
      } | null;
      readonly id: string;
      readonly name: string;
    };
  };
};
export type StorecastScreenAdminSelectDashboardMutation = {
  response: StorecastScreenAdminSelectDashboardMutation$data;
  variables: StorecastScreenAdminSelectDashboardMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dashboardId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "screenId"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StorecastMutation",
    "kind": "LinkedField",
    "name": "storecast",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "dashboardId",
            "variableName": "dashboardId"
          },
          {
            "kind": "Variable",
            "name": "screenId",
            "variableName": "screenId"
          }
        ],
        "concreteType": "StorecastScreen",
        "kind": "LinkedField",
        "name": "setScreenDashboard",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Dashboard",
            "kind": "LinkedField",
            "name": "dashboard",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "StorecastScreenAdminSelectDashboardMutation",
    "selections": (v4/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "StorecastScreenAdminSelectDashboardMutation",
    "selections": (v4/*: any*/)
  },
  "params": {
    "cacheID": "0fa585495d5c2df31e4930dfde1d4716",
    "id": null,
    "metadata": {},
    "name": "StorecastScreenAdminSelectDashboardMutation",
    "operationKind": "mutation",
    "text": "mutation StorecastScreenAdminSelectDashboardMutation(\n  $screenId: ID!\n  $dashboardId: ID!\n) {\n  storecast {\n    setScreenDashboard(screenId: $screenId, dashboardId: $dashboardId) {\n      id\n      name\n      dashboard {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "18e31b7d97a84ef52de6ebc47d474a3d";

export default node;
